export const getSubmissionDataPath = (
    submissionId: string,
    withDetails: boolean,
) => `/rest/submission/${submissionId}${withDetails ? '?withDetails=true' : ''}`;

export default (appDomain: string, submissionId: string, withDetails: boolean) => `${window.location.protocol}//${appDomain}${getSubmissionDataPath(submissionId, withDetails)}`;
